export default {
    Default: {
        bro: {
            format: '',
        },
        dest: {
            host: 'localhost',
            port: '514',
            proto: 'UDP',
            url: '',
        },
        elk: {
            debug_log: false,
            dst_tz: 'UTC',
            ecs: {
                enabled: false,
                version: '8.2.1'
            },
            index: '',
            index_rotate_days: 0,
            validate_ssl_host: true,
            validate_ssl_peer: true,
        },
        event_types: [
            'bro_log',
            'alert',
            'health_alert',
            'dpi'
        ],
        export_type: 'syslog',
        filterconf: {
            filters: [],
            filtertypes: ['inactive', 'black', 'white'],
            selfiltertype: 'inactive',
        },
        frame_sep_nl: false,
        mark: {
            enable: false,
            timeout: 11,
        },
        prune_keys: null,
        prune_type: 'inactive',
        syslog: {
            dst_tz: 'UTC',
            facility: 19,
            format: '$cmc_name$ LEEF:1.0|Bricata|Bricata|$sys_version$|$signature_id$|cat=detected   devTime=$timestamp$     proto=$proto$   sev=$severity$  src=$src_ip$    dst=$dst_ip$    srcPort=$src_port$      dstPort=$dst_port$      msg=$signature$ dvc=$sensor_ip$ dvchost=$sensor_name$   cs3=$cmc_ip$    cs3Label=CMC-IP   cs4=$cmc_name$  cs4Label=BricataCmcHostname     categoryDeviceGroup=/IDS/Network',
            frame_separator: '',
            rfc: 'new',
            severity: 1,
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        webhook: {
            url: '',
            proxy: '',
            format: '',
            auth: '',
            validate_ssl_peer: true,
            validate_ssl_host: true,
        },
        snmp: {
            community: '',
        },
        tags: {
            action: '',
            vals: [''],
        },
        tls_cert: {
            contents: '',
            enable: false,
            file_name: '',
        },
        tls_client_cert: {
            contents: '',
            enable: false,
            file_name: '',
        },
        tls_client_key: {
            contents: '',
            enable: false,
            file_name: '',
        },
        tls_fips: false,
        tls_client_auth: false,
    },
    'Splunk-conn': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9001',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:proto@\t@bro_log:service@\t@bro_log:duration@\t@bro_log:orig_bytes@\t@bro_log:resp_bytes@\t@bro_log:conn_state@\t@bro_log:local_orig@\t@bro_log:local_resp@\t@bro_log:missed_bytes@\t@bro_log:history@\t@bro_log:orig_pkts@\t@bro_log:orig_ip_bytes@\t@bro_log:resp_pkts@\t@bro_log:resp_ip_bytes@\t@bro_log:tunnel_parents@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'conn-only',
                    filter: {
                        filter: "bricata:event_source = 'conn'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-dhcp': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9002',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:mac@\t@bro_log:assigned_ip@\t@bro_log:lease_time@\t@bro_log:trans_id@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'dhcp-only',
                    filter: {
                        filter: "bricata:event_source = 'dhcp'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-dns': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9003',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:proto@\t@bro_log:trans_id@\t@bro_log:rtt@\t@bro_log:query@\t@bro_log:qclass@\t@bro_log:qclass_name@\t@bro_log:qtype@\t@bro_log:qtype_name@\t@bro_log:rcode@\t@bro_log:rcode_name@\t@bro_log:AA@\t@bro_log:TC@\t@bro_log:RD@\t@bro_log:RA@\t@bro_log:Z@\t@bro_log:answers@\t@bro_log:TTLs@\t@bro_log:rejected@\t@bro_log:auth@\t@bro_log:addl@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'dns-only',
                    filter: {
                        filter: "bricata:event_source = 'dns'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-dpd': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9004',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:proto@\t@bro_log:analyzer@\t@bro_log:failure_reason@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'dpd-only',
                    filter: {
                        filter: "bricata:event_source = 'dpd'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-files': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9005',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:tx_host@\t@bro_log:rx_host@\t@bro_log:conn_uids@\t@bro_log:source@\t@bro_log:depth@\t@bro_log:analyzers@\t@bro_log:mime_type@\t@bro_log:filename@\t@bro_log:duration@\t@bro_log:local_orig@\t@bro_log:is_orig@\t@bro_log:seen_bytes@\t@bro_log:total_bytes@\t@bro_log:missing_bytes@\t@bro_log:overflow_bytes@\t@bro_log:timedout@\t@bro_log:parent_fuid@\t@bro_log:md5@\t@bro_log:sha1@\t@bro_log:sha256@\t@bro_log:extracted@\t@bro_log:extracted_cutoff@\t@bro_log:extracted_size@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'files-only',
                    filter: {
                        filter: "bricata:event_source = 'files'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-ftp': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9006',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:user@\t@bro_log:password@\t@bro_log:command@\t@bro_log:arg@\t@bro_log:mime_type@\t@bro_log:file_size@\t@bro_log:reply_code@\t@bro_log:reply_msg@\t@bro_log:data_channel.passive@\t@bro_log:data_channel.orig_h@\t@bro_log:data_channel.resp_h@\t@bro_log:data_channel.resp_p@\t@bro_log:fuid@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'ftp-only',
                    filter: {
                        filter: "bricata:event_source = 'ftp'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-http': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9007',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:trans_depth@\t@bro_log:method@\t@bro_log:host@\t@bro_log:uri@\t@bro_log:referrer@\t@bro_log:version@\t@bro_log:user_agent@\t@bro_log:request_body_len@\t@bro_log:response_body_len@\t@bro_log:status_code@\t@bro_log:status_msg@\t@bro_log:info_code@\t@bro_log:info_msg@\t@bro_log:tags@\t@bro_log:username@\t@bro_log:password@\t@bro_log:proxied@\t@bro_log:orig_fuids@\t@bro_log:orig_filenames@\t@bro_log:orig_mime_types@\t@bro_log:resp_fuids@\t@bro_log:resp_filenames@\t@bro_log:resp_mime_types@\t@bro_log:client_header_names@\t@bro_log:server_header_names@\t@bro_log:url@\t@bro_log:cookie_vars@\t@bro_log:uri_vars@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'http-only',
                    filter: {
                        filter: "bricata:event_source = 'http'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-intel': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9008',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:seen.indicator@\t@bro_log:seen.indicator_type@\t@bro_log:seen.where@\t@bro_log:seen.node@\t@bro_log:seen@\t@bro_log:matched@\t@bro_log:sources@\t@bro_log:fuid@\t@bro_log:file_mime_type@\t@bro_log:file_desc@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'intel-only',
                    filter: {
                        filter: "bricata:event_source = 'intel'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-irc': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9009',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:nick@\t@bro_log:user@\t@bro_log:command@\t@bro_log:value@\t@bro_log:addl@\t@bro_log:dcc_file_name@\t@bro_log:dcc_file_size@\t@bro_log:dcc_mime_type@\t@bro_log:fuid@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'irc-only',
                    filter: {
                        filter: "bricata:event_source = 'irc'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-kerberos': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9010',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:request_type@\t@bro_log:client@\t@bro_log:service@\t@bro_log:success@\t@bro_log:error_msg@\t@bro_log:from@\t@bro_log:till@\t@bro_log:cipher@\t@bro_log:forwardable@\t@bro_log:renewable@\t@bro_log:client_cert_subject@\t@bro_log:client_cert_fuid@\t@bro_log:server_cert_subject@\t@bro_log:server_cert_fuid@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'kerberos-only',
                    filter: {
                        filter: "bricata:event_source = 'kerberos'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-notice': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9011',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:fuid@\t@bro_log:file_mime_type@\t@bro_log:file_desc@\t@bro_log:proto@\t@bro_log:note@\t@bro_log:msg@\t@bro_log:sub@\t@bro_log:src@\t@bro_log:dst@\t@bro_log:p@\t@bro_log:n@\t@bro_log:peer_descr@\t@bro_log:actions@\t@bro_log:suppress_for@\t@bro_log:remote_location@\t@bro_log:dropped@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'notice-only',
                    filter: {
                        filter: "bricata:event_source = 'notice'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-ntlm': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9012',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:domainname@\t@bro_log:hostname@\t@bro_log:username@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'ntlm-only',
                    filter: {
                        filter: "bricata:event_source = 'ntlm'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-pe': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9013',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:machine@\t@bro_log:compile_ts@\t@bro_log:os@\t@bro_log:subsystem@\t@bro_log:is_exe@\t@bro_log:is_64bit@\t@bro_log:uses_aslr@\t@bro_log:uses_dep@\t@bro_log:uses_code_integrity@\t@bro_log:uses_seh@\t@bro_log:has_import_table@\t@bro_log:has_export_table@\t@bro_log:has_debug_data@\t@bro_log:section_names@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'pe-only',
                    filter: {
                        filter: "bricata:event_source = 'pe'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-radius': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9014',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:username@\t@bro_log:mac@\t@bro_log:remote_ip@\t@bro_log:connect_info@\t@bro_log:result@\t@bro_log:logged@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'radius-only',
                    filter: {
                        filter: "bricata:event_source = 'radius'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-rdp': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9015',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:cookie@\t@bro_log:result@\t@bro_log:security_protocol@\t@bro_log:keyboard_layout@\t@bro_log:client_build@\t@bro_log:client_name@\t@bro_log:client_dig_product_id@\t@bro_log:desktop_width@\t@bro_log:desktop_height@\t@bro_log:requested_color_depth@\t@bro_log:cert_type@\t@bro_log:cert_count@\t@bro_log:cert_permanent@\t@bro_log:encryption_level@\t@bro_log:ecryption_method@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'rdp-only',
                    filter: {
                        filter: "bricata:event_source = 'rdp'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-sip': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9016',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:trans_depth@\t@bro_log:method@\t@bro_log:uri@\t@bro_log:date@\t@bro_log:request_from@\t@bro_log:request_to@\t@bro_log:response_from@\t@bro_log:response_to@\t@bro_log:reply_to@\t@bro_log:call_id@\t@bro_log:seq@\t@bro_log:subject@\t@bro_log:request_path@\t@bro_log:response_path@\t@bro_log:user_agent@\t@bro_log:status_code@\t@bro_log:status_msg@\t@bro_log:warning@\t@bro_log:request_body_len@\t@bro_log:response_body_len@\t@bro_log:content_type@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'sip-only',
                    filter: {
                        filter: "bricata:event_source = 'sip'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-smb': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9017',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:path@\t@bro_log:service@\t@bro_log:share_type@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'smb-only',
                    filter: {
                        filter: "bricata:event_source = 'smb_mapping'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-smtp': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9018',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:trans_depth@\t@bro_log:helo@\t@bro_log:mailfrom@\t@bro_log:rcptto@\t@bro_log:date@\t@bro_log:from@\t@bro_log:to@\t@bro_log:cc@\t@bro_log:reply_to@\t@bro_log:msg_id@\t@bro_log:in_reply_to@\t@bro_log:subject@\t@bro_log:x_originating_ip@\t@bro_log:first_received@\t@bro_log:second_received@\t@bro_log:last_reply@\t@bro_log:path@\t@bro_log:useragent@\t@bro_log:tls@\t@bro_log:fuids@\t@bro_log:is_webmail@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'smtp-only',
                    filter: {
                        filter: "bricata:event_source = 'smtp'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-snmp': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9019',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:duration@\t@bro_log:version@\t@bro_log:community@\t@bro_log:get_request\t@bro_log:get_bulk_request\t@bro_log:get_responses@\t@bro_log:set_request\t@bro_log:display_string@\t@bro_log:up_since@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'snmp-only',
                    filter: {
                        filter: "bricata:event_source = 'snmp'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-socks': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9020',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:version@\t@bro_log:user@\t@bro_log:password@\t@bro_log:status@\t@bro_log:request@\t@bro_log:request_p@\t@bro_log:bound@\t@bro_log:bound_p@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'socks-only',
                    filter: {
                        filter: "bricata:event_source = 'socks'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-software': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9021',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:host@\t@bro_log:host_p@\t@bro_log:software_type@\t@bro_log:name@\t@bro_log:major@\t@bro_log:minor@\t@bro_log:minor2@\t@bro_log:minor3@\t@bro_log:addl@\t@bro_log:unparsed_version@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'software-only',
                    filter: {
                        filter: "bricata:event_source = 'software'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-ssh': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9022',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:version@\t@bro_log:auth_success@\t@bro_log:auth_attempt\t@bro_log:direction@\t@bro_log:client@\t@bro_log:server@\t@bro_log:cipher_alg@\t@bro_log:mac_alg@\t@bro_log:compression_alg@\t@bro_log:kex_alg@\t@bro_log:host_key_alg@\t@bro_log:host_key@\t@bro_log:destination_country_code@\t@bro_log:destination_region@\t@bro_log:destination_city@\t@bro_log:destination_latitude@\t@bro_log:destination_longitude@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'ssh-only',
                    filter: {
                        filter: "bricata:event_source = 'ssh'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-ssl': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9023',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:version@\t@bro_log:cipher@\t@bro_log:curve@\t@bro_log:server_name@\t@bro_log:resumed@\t@bro_log:last_alert@\t@bro_log:next_protocol@\t@bro_log:established@\t@bro_log:cert_chain_fuids@\t@bro_log:client_cert_chain_fuids@\t@bro_log:subject@\t@bro_log:issuer@\t@bro_log:client_subject@\t@bro_log:client_issuer@\t@bro_log:validation_status@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'ssl-only',
                    filter: {
                        filter: "bricata:event_source = 'ssl'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-syslog': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9024',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:proto@\t@bro_log:facility@\t@bro_log:severity@\t@bro_log:message@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'syslog-only',
                    filter: {
                        filter: "bricata:event_source = 'syslog'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-tunnel': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9025',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:tunnel_type@\t@bro_log:action@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'tunnel-only',
                    filter: {
                        filter: "bricata:event_source = 'tunnel'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-weird': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9026',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:id.orig_h@\t@bro_log:id.orig_p@\t@bro_log:id.resp_h@\t@bro_log:id.resp_p@\t@bro_log:name@\t@bro_log:addl@\t@bro_log:notice@\t@bro_log:peer@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'weird-only',
                    filter: {
                        filter: "bricata:event_source = 'weird'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    },
    'Splunk-x509': {
        dest: {
            proto: 'TCP',
            host: 'localhost',
            port: '9027',
            url: ''
        },
        export_type: 'bro',
        event_types: [
            'bro_log'
        ],
        syslog: {
            format: '',
            severity: 1,
            facility: 19,
            rfc: 'new',
            dst_tz: 'UTC',
            frame_separator: ''
        },
        kafka: {
            brokers: '',
            topic: '',
            retries: 3,
            compression: false,
            ssl_cipher_suites: 'HIGH:!kRSA:!MD5:!RC4:!SHA1',
            message_max_bytes: 1000000,
            queue_buffering_max_messages: 100000,
            queue_buffering_max_kbytes: 1048576,
            queue_buffering_max_ms: 11,
            headers: []
        },
        elk: {
            index: '',
            index_rotate_days: 0,
            dst_tz: 'UTC',
            validate_ssl_host: true,
            validate_ssl_peer: true,
            debug_log: false,
            ecs: {
                enabled: false,
                version: '1.2.0'
            }
        },
        bro: {
            format: '$timestamp_epoch_fract$\t@bro_log:uid@\t@bro_log:certificate.version@\t@bro_log:certificate.serial@\t@bro_log:certificate.subject@\t@bro_log:certificate.issuer@\t@bro_log:certificate.not_valid_before@\t@bro_log:certificate.not_valid_after@\t@bro_log:certificate.key_alg@\t@bro_log:certificate.sig_alg@\t@bro_log:certificate.key_type@\t@bro_log:certificate.key_length@\t@bro_log:certificate.exponent@\t@bro_log:certificate.curve@\t@bro_log:san.dns@\t@bro_log:san.uri@\t@bro_log:san.email@\t@bro_log:san.ip@\t@bro_log:basic_constraints.ca@\t@bro_log:basic_constraints.path_len@'
        },
        tags: {
            action: '',
            vals: [
                ''
            ]
        },
        mark: {
            enable: false,
            timeout: 11
        },
        tls_cert: {
            enable: false,
            file_name: '',
            contents: ''
        },
        tls_fips: false,
        filterconf: {
            filtertypes: [
                'inactive',
                'black',
                'white'
            ],
            selfiltertype: 'white',
            filters: [
                {
                    note: 'x509-only',
                    filter: {
                        filter: "bricata:event_source = 'x509'"
                    },
                    id: 0,
                    created_by: 'admin',
                    enabled: true,
                    new: true,
                    updated_by: 'admin',
                }
            ]
        },
        frame_sep_nl: false
    }
};
